module.exports = __webpack_public_path__ + "img/DemolitionExpert2.558ebb0a.png";